(() => {
  if (window.mafKitComparisonBound) return;
  window.mafKitComparisonBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-maf-kit-purchase]');
    if (!button || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    const error = button.closest('.kit-offer').querySelector('.kit-offer__error');
    error.hidden = true;
    const label = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    try {
      const data = document.getElementById(button.dataset.itemsId);
      const items = JSON.parse(data.textContent);
      if (!Array.isArray(items) || !items.length || items.some(item => !/^\d+$/.test(String(item.id)) || Number(item.id) <= 0 || !Number.isInteger(item.quantity) || item.quantity < 1)) throw new Error('This offer is unavailable. Please open its product page.');
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('We could not add this offer. Please check availability on the product page.');
      window.location.assign(button.dataset.cartUrl || root + 'cart');
    } catch (failure) {
      error.textContent = failure.message || 'We could not add this offer. Please try again.';
      error.hidden = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }
  });
})();
